/**
 * Notification types.
 */
export const NOTIFICATION_TYPES: NotificationTypeSpec[] = [
  {
    id: 'JobClosed',
    title: 'Job Closed',
    description: 'Receive notifications when a job has been closed.',
  },
  {
    id: 'JobReopened',
    title: 'Job Reopened',
    description: 'Receive notifications when a job has been reopened.',
  },
  {
    id: 'JobUpdated',
    title: 'Job Updated',
    description: 'Receive notifications when a job has been updated.',
  },
  {
    id: 'NewJobAvailable',
    title: 'New Job Available',
    description: 'Receive notifications when a new job is available.',
  },
  {
    id: 'NewMessage',
    title: 'New Message',
    description: 'Receive notifications when you receive a new message.',
  },
  {
    id: 'UnreadMessage',
    title: 'Unread Message',
    description: 'Receive notifications if you have an unread message.',
  },
  {
    id: 'UnreadDocument',
    title: 'Unread Document',
    description: 'Receive notifications if you have an unread document.',
  },
]

/**
 * Notification type specification.
 */
export interface NotificationTypeSpec {
  id: string
  title: string
  description: string
}
